import { useQuery } from 'react-query';
import { network } from 'services/network';

const getLargestDurationVarianceTableData = (params) => {
    const payload = {
        compareVersionId: params.compareVersionId,
        contractId: params.contractId,
        latestVersionId: params.latestVersionId,
        projectId: params.projectId,
        filter: params.filterData,
    };
    return network
        .post('api/bo/getLargestDurationVariance', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            throw error;
        });
};

export const useQueryLargestDurationVarianceTableData = (params) => {
    return useQuery(['largestDurationVarianceTableData', params], () => getLargestDurationVarianceTableData(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
